import styled from '@emotion/styled/macro';
import vars from '@variables';

export const UnorderedListAtom = styled.ul`
  margin-left: 3.3rem;
  margin-bottom: ${vars.spacingM};
  list-style: outside;
  text-align: left;
  ${vars.fontSize4}
  line-height: 1.6;
  letter-spacing: 0.0015em;
  p {
    margin: 0 0 ${vars.spacingXs} 0;
  }
`;

export const OrderedListAtom = styled.ol`
  margin-left: 3.3rem;
  margin-bottom: ${vars.spacingM};
  text-align: left;
  ${vars.fontSize4}
  line-height: 1.6;
  letter-spacing: 0.0015em;
  p {
    margin: 0 0 ${vars.spacingXs} 0;
  }
`;
